import React from 'react';
import { ConfigProvider } from 'antd';
import enGB from 'antd/locale/en_GB';
import dayjs from 'dayjs';
import { Provider as ReduxProvider } from 'react-redux';
import {
  Route,
  RouterProvider,
  createBrowserRouter,
  createRoutesFromElements,
} from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import ToastMessage from './components/ToastMessage/ToastMessage';
import { RouteNames, routesAccessRights } from './constans/routes';
import AppOutlet from './HOC/AppOutlet/AppOutlet';
import LogoOutlet from './HOC/LogoOutlet/LogoOutlet';
import store from './redux/store';
import GuardedElement from './routing/AuthGuard';
import { GlobalStyle } from './styles/globals';
import { THEME } from './styles/theme';
import Page404 from './views/404/404';
import CreateSurvey from './views/CreateSurvey/CreateSurvey';
import ForgotPassword from './views/ForgotPassword/ForgotPassword';
import IndividualReport from './views/IndividualReport/IndividualReport';
import Login from './views/Login/Login';
import Logout from './views/Logout/Logout';
import NewPassword from './views/NewPassword/NewPassword';
import OrgSettings from './views/OrgSettings/OrgSettings';
import Report from './views/Report/Report';
import Reports from './views/Reports/Reports';
import SessionExpired from './views/SessionExpired/SessionExpired';
import Surveys from './views/Surveys/Surveys';
import 'dayjs/locale/en-gb';

dayjs.locale('en-gb');

function App() {
  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route path={RouteNames.Login}>
        <Route element={<LogoOutlet />}>
          <Route path={RouteNames.Login} element={<Login />} />
          <Route path={RouteNames.Logout} element={<Logout />} />
          <Route path={RouteNames.Page404} element={<Page404 />} />
          <Route path={RouteNames.SessionExpired} element={<SessionExpired />} />
          <Route path={RouteNames.PasswordReset} element={<ForgotPassword />} />
          <Route path={RouteNames.PasswordResetConfirm} element={<NewPassword />} />
          <Route path="*" element={<Page404 />} />
        </Route>
        <Route element={<AppOutlet />}>
          <Route
            path={RouteNames.Surveys}
            element={
              <GuardedElement
                component={<Surveys />}
                requiredRoles={routesAccessRights[RouteNames.Surveys]}
              />
            }
          />
          <Route
            path={`${RouteNames.CreateSurvey}/:surveyId`}
            element={
              <GuardedElement
                component={<CreateSurvey />}
                requiredRoles={routesAccessRights[RouteNames.Surveys]}
              />
            }
          />
          <Route
            path={`${RouteNames.Reports}`}
            element={
              <GuardedElement
                component={<Reports />}
                requiredRoles={routesAccessRights[RouteNames.Reports]}
              />
            }
          />
          <Route
            path={`${RouteNames.Reports}/:reportId`}
            element={
              <GuardedElement
                component={<Report />}
                requiredRoles={routesAccessRights[RouteNames.Reports]}
              />
            }
          />
          <Route
            path={RouteNames.OrgSettings}
            element={
              <GuardedElement
                component={<OrgSettings />}
                requiredRoles={routesAccessRights[RouteNames.OrgSettings]}
              />
            }
          />
        </Route>
        <Route path={RouteNames.Results}>
          <Route
            path={`${RouteNames.Results}/report/:slug/:token`}
            element={<IndividualReport />}
          />
        </Route>
      </Route>
    ),
    { basename: '/' }
  );

  return (
    <ReduxProvider store={store}>
      <ConfigProvider locale={enGB}>
        <ThemeProvider theme={THEME}>
          <GlobalStyle theme={THEME} />
          <RouterProvider router={router} />
          <ToastMessage />
        </ThemeProvider>
      </ConfigProvider>
    </ReduxProvider>
  );
}

export default App;
